import React from 'react/addons';
import $ from 'jquery';

import EntryPoint from 'ofs/apps/core/entry';
import GuestList from './models/guest-list';
import BedConfiguration from './models/bed-configuration';
import SaveButton from 'ofs/apps/bookings/prestay/views/SaveButton';
import markers from 'ofs/google/maps/markers';
import RequestChangeForm from './views/RequestChangeForm';
import ResponsiveBreadbar from '../views/ResponsiveBreadbar';

class GuestsEntryPoint extends EntryPoint {
  renderToDocument(document) {
    if (!standalone) {
      super.renderToDocument(document);
    }

    const {prestay, standalone, unit, form} = this.options;
    const {config, bookingRef} = prestay;

    let BedConfigurationView, bedConfigurationModel;
    let AdditionalGuestsView, additionalGuestsModel;

    const $bedConfigForm = $('.bed-configuration-form').get(0);
    const $saveButton = $('.save-button').get(0);

    if (config.bedConfigOnly && config.haveBedsBeenConfigured) {
      BedConfigurationView = require('./views/bed-configuration')(config);
      bedConfigurationModel = new BedConfiguration();

      if (prestay.bedBillables) {
        bedConfigurationModel.set('bed_billables', config.bedBillables);
      }

      if (config.bedConfiguration && config.bedConfiguration.bedDescriptions) {
        bedConfigurationModel.set('bed_descriptions', config.bedConfiguration.bedDescriptions);
      }

      bedConfigurationModel.setTotalGuestsCount(config.totalGuests);
      bedConfigurationModel.parse(prestay.bedConfiguration, true);

      if ($bedConfigForm) {
        React.withContext({flux: this.flux}, () => {
          React.render(
            <BedConfigurationView model={bedConfigurationModel} active={true} />,
            $bedConfigForm
          );
        });
      }
    }

    if (!config.bedConfigOnly) {
      // TODO
      AdditionalGuestsView = require('./views/additional-guests')(
        config.additionalGuests
      );
      additionalGuestsModel = new GuestList(prestay.additionalGuests);

      React.render(
        <AdditionalGuestsView collection={additionalGuestsModel} />,
        $('.additional-guests-form').get(0)
      );

      BedConfigurationView = require('./views/bed-configuration')(
        config.bedConfiguration
      );
      bedConfigurationModel = new BedConfiguration();

      bedConfigurationModel.setAdditionalGuestsModel(additionalGuestsModel);
      bedConfigurationModel.set(
        'bed_descriptions',
        config.bedConfiguration.bedDescriptions
      );
      bedConfigurationModel.set(
        'bed_billables',
        config.bedConfiguration.bedBillables
      );

      bedConfigurationModel.setInitalData(prestay.bedConfiguration);
      bedConfigurationModel.parse(prestay.bedConfiguration, true);

      if ($bedConfigForm) {
        React.withContext({flux: this.flux}, () => {
          React.render(
            <BedConfigurationView model={bedConfigurationModel} active={bedConfigurationModel.hasSelection()} />,
            $bedConfigForm
          );
        });
      }

      if ($saveButton)
      React.render(
        <SaveButton model={bedConfigurationModel} collection={additionalGuestsModel} email={config.additionalGuests.guestServicesEmail} phone={config.additionalGuests.guestServicesPhone}/>,
        $saveButton
      );
    }

    // for the Request Change popup when booking is confirmed
    $('#request-change').on('click', (event) => {
      event.preventDefault();
      this.flux.actions.layers.addModal(<RequestChangeForm formData={form} />);
    });

    // expand accordions
    $('.ofs-BookingCard__Wrapper--accordion').on('click', (event) => {
      const $panel = $(event.target).parent();
      $panel.find('.ofs-BookingCard__Content--collapsed').slideToggle();
      $panel.find('.ofs-Icon--arrow').toggleClass('ofs-Icon--arrow-right', 'ofs-Icon--arrow-down');
    });

    // embed google maps to home when booking is confirmed
    if (document.getElementById('map-block')) {
      const position = new google.maps.LatLng(unit.latitude, unit.longitude);
      const map = new google.maps.Map(document.getElementById('map-block'), {
        center: position,
        zoom: 15
      });
      new google.maps.Marker({
        position: position,
        map: map,
        icon: markers.home,
        optimized: false,
      });
    }

    const breadbar = document.getElementById('breadbar');
    if (breadbar) {
      React.render(<ResponsiveBreadbar bookingRef={bookingRef} currentPage='book-capture-guests' />, breadbar);
    }
  }
}

module.exports = GuestsEntryPoint;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/entry.jsx
 **/